export default __webpack_public_path__ + "static/Shepherd-Pie-COOKED-2-c40f5ca2b5f52f4340880c7a4600fb58.png";